<template>
  <ValidationObserver v-slot="{ invalid }">
    <div class="h-screen flex w-full bg-img">
      <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
        <vx-card>
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row">
              <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
              </div>
              <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                <div class="p-8">
                  <div class="vx-card__title mb-8">
                    <h4 class="mb-4">{{ $t('user.change-password') }}</h4>
                    <p>{{ $t(changePasswordReason) }} {{ $t('user.please-change-password') }}</p>
                  </div>

                  <div class="vx-row">
                    <div class="vx-col w-full mb-2">
                      <ValidationProvider v-slot="{ errors }" :name="$t('profile.new-password')"
                                          rules="required|min:8|password:@confirm" vid="newpassword">
                        <vs-input v-model="form.newPassword"
                                  :label-placeholder="$t('profile.new-password')"
                                  class="w-full"
                                  type="password"/>
                        <span v-show="errors[0]" class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col w-full mb-6">
                      <ValidationProvider v-slot="{ errors }" :name="$t('profile.retype-new-password')"
                                          rules="required|min:8|password:@newpassword" vid="confirm">
                        <vs-input v-model="form.retypeNewPassword"
                                  :label-placeholder="$t('profile.retype-new-password')"
                                  class="w-full"
                                  type="password"/>
                        <span v-show="errors[0]" class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>


                  <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                    <vs-button type="border"
                               to="/user/login"
                               :disabled="processing"
                               class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">
                      {{ $t('user.back-to-login') }}
                    </vs-button>
                    <vs-button :disabled="processing || invalid"
                               class="w-full sm:w-auto"
                               @click.prevent="handlerSaveClick">
                      {{ $t('user.change-password') }}
                    </vs-button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import {showLocalNotification, notificationType} from "@/utils/notification";
import {extend} from 'vee-validate';
// import axios from "axios";
import axios from "@/setup/axios-setup";

extend('password', {
  params: ['target'],
  validate(value, {target}) {
    if (target) {
      return value === target;
    }
    return true
  },
  message: 'รหัสผ่านไม่ตรงกัน'
});



export default {
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        retypeNewPassword: '',
      },
      processing: false,
      changePasswordReason: ''
    }
  },
  methods: {
    async handlerSaveClick() {
      if(this.$route.params.oldPassword === this.form.newPassword){
        showLocalNotification(
          this.$vs,
          this.$t('general.error'),
          this.$t('profile.new-password-match-old-password'),
          notificationType.ERROR
        );
        return
      }
      const payload = {
        username: this.$route.params.username,
        oldPassword: this.$route.params.oldPassword,
        newPassword: this.form.newPassword,
      };
      const response = await axios({
        method: "post",
        url: process.env.VUE_APP_AUTH_SERVER + "/reset-password",
        data: payload,
      })
      const { data } = response
      if (data.status.success) {
        showLocalNotification(
          this.$vs,
          this.$t('general.success'),
          this.$t('profile.reset-password-success'),
          notificationType.SUCCESS
        );
        //go to login
        this.gotoLogin();
      } else {
        showLocalNotification(
          this.$vs,
          this.$t('general.error'),
          data.status.message,
          notificationType.ERROR
        );
      }
    },
    gotoLogin(){
      this.$router.push('/user/login')
    }
  },
  beforeMount() {
    if(!this.$route.params.username || !this.$route.params.oldPassword || !this.$route.params.changePasswordReason){
      this.gotoLogin();
    }else{
      this.changePasswordReason = this.$route.params.changePasswordReason
    }
  }
}
</script>
